var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0435 10.9563H32.2946C32.5285 10.9547 32.7573 11.0286 32.9511 11.1683C33.1449 11.3079 33.2946 11.5069 33.3804 11.7389L35.4348 17.2172",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56494 20.3477H26.0433",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 30.5215C29.9448 30.5215 31.5215 28.9448 31.5215 26.9998C31.5215 25.0548 29.9448 23.478 27.9998 23.478C26.0548 23.478 24.478 25.0548 24.478 26.9998C24.478 28.9448 26.0548 30.5215 27.9998 30.5215Z",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 30.5215C11.9453 30.5215 13.522 28.9448 13.522 26.9998C13.522 25.0548 11.9453 23.478 10.0003 23.478C8.05526 23.478 6.47852 25.0548 6.47852 26.9998C6.47852 28.9448 8.05526 30.5215 10.0003 30.5215Z",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4785 26.6084H13.522",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0867 26.6087H3.73886C3.42752 26.6087 3.12893 26.4902 2.90877 26.2792C2.68862 26.0682 2.56494 25.7821 2.56494 25.4837V9.73365C2.56494 9.43528 2.68862 9.14913 2.90877 8.93815C3.12893 8.72717 3.42752 8.60864 3.73886 8.60864H26.0433V23.6837",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0435 17.217H35.4348V25.5649C35.4348 25.8417 35.3111 26.1071 35.091 26.3028C34.8708 26.4985 34.5722 26.6084 34.2609 26.6084H32.3044",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.35a32cf1e3a1ab83dac974160206351d.svg";
export { ForwardRef as ReactComponent };